/*******************************************************************************
 * utils.js - Utility Functions
 ******************************************************************************/

import { API_ENDPOINTS } from './constants.js';

/**
 * Get element by ID
 * @param {string} id - Element ID
 * @returns {HTMLElement|null}
 */
export function getElement(id) {
    return document.getElementById(id);
}

/**
 * Get Syncfusion grid instance
 * @param {string} id - Grid element ID
 * @returns {object|null} - Syncfusion grid instance
 */
export function getGrid(id) {
    var el = getElement(id || "Grid");
    return el && el.ej2_instances ? el.ej2_instances[0] : null;
}

/**
 * Show element by setting display to block
 * @param {string} id - Element ID
 */
export function showElement(id) {
    var el = getElement(id);
    if (el) el.style.display = "block";
}

/**
 * Hide element by setting display to none
 * @param {string} id - Element ID
 */
export function hideElement(id) {
    var el = getElement(id);
    if (el) el.style.display = "none";
}

/**
 * Set visibility of element
 * @param {string} id - Element ID
 * @param {boolean} visible - Whether to show or hide
 */
export function setVisibility(id, visible) {
    var el = getElement(id);
    if (el) el.style.visibility = visible ? "visible" : "hidden";
}

/**
 * Show dialog container (using jQuery for visibility)
 * @param {string} containerId - Container element ID
 */
export function showDialog(containerId) {
    $("#" + containerId).css("visibility", "visible");
}

/**
 * Hide dialog container (using jQuery for visibility)
 * @param {string} containerId - Container element ID
 */
export function hideDialog(containerId) {
    $("#" + containerId).css("visibility", "hidden");
}

/**
 * Format currency with symbol
 * @param {number} amount - Amount to format
 * @param {string} countryCode - Country code (GB for pounds, others for dollars)
 * @returns {string} - Formatted currency string
 */
export function formatCurrency(amount, countryCode) {
    var symbol = countryCode === "GB" ? "£" : "$";
    return symbol + amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
}

/**
 * Debounce function to limit rapid calls
 * @param {Function} func - Function to debounce
 * @param {number} wait - Wait time in milliseconds
 * @returns {Function} - Debounced function
 */
export function debounce(func, wait) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            func.apply(context, args);
        }, wait);
    };
}

/**
 * Chunk an array into smaller arrays
 * @param {Array} myArray - Array to chunk
 * @param {number} chunk_size - Size of each chunk
 * @returns {Array} - Array of chunks
 */
export function chunkArray(myArray, chunk_size) {
    let index = 0;
    let arrayLength = myArray.length;
    let tempArray = [];

    for (index = 0; index < arrayLength; index += chunk_size) {
        let chunk = myArray.slice(index, index + chunk_size);
        tempArray.push(chunk);
    }
    return tempArray;
}

/**
 * Pad number to 2 digits
 * @param {number} num - Number to pad
 * @returns {string} - Padded string
 */
export function padTo2Digits(num) {
    return num.toString().padStart(2, '0');
}

/**
 * Format date to dd/mm/yyyy
 * @param {Date} date - Date to format
 * @returns {string} - Formatted date string
 */
export function formatDate(date) {
    return [
        padTo2Digits(date.getDate()),
        padTo2Digits(date.getMonth() + 1),
        date.getFullYear()
    ].join('/');
}

/**
 * Parse string to boolean
 * @param {string} str - String to parse
 * @returns {boolean}
 */
export function parseBool(str) {
    return str.toLowerCase() === 'true';
}

/**
 * Check if character is a number
 * @param {string} c - Character to check
 * @returns {boolean}
 */
export function isCharNumber(c) {
    return typeof c === 'string' && c.length === 1 && c >= '0' && c <= '9';
}

/**
 * Find row index in grid by invoice ID
 * @param {object} grid - Syncfusion grid instance
 * @param {string} invoiceID - Invoice ID to find
 * @returns {number} - Row index or -1 if not found
 */
export function findRowIndexById(grid, invoiceID) {
    var data = grid.getCurrentViewRecords();
    for (var i = 0; i < data.length; i++) {
        if (data[i].invoiceID === invoiceID) {
            return i;
        }
    }
    return -1;
}
